import { SubscriptionTable } from './subscription-table.model';

export const eventDescriptors: Array<{ prop: keyof SubscriptionTable; event: string }> = [
  { prop: 'email', event: 'email' },
  { prop: 'voice', event: 'voice' },
  { prop: 'sms', event: 'sms' },
  { prop: 'push', event: 'push' },
  { prop: 'offer', event: 'offer' },
  { prop: 'performance', event: 'performance' },
  { prop: 'coachingEmail', event: 'coachingEmail' },
  { prop: 'coachingVoice', event: 'coachingVoice' },
  { prop: 'coachingSms', event: 'coachingSms' },
  { prop: 'coachingPush', event: 'coachingPush' },
  { prop: 'paymentEmail', event: 'paymentEmail' },
  { prop: 'remindersEmail', event: 'remindersEmail' },
  { prop: 'remindersPush', event: 'remindersPush' },
];
